import React from 'react';
import { Card } from 'antd';

import "antd/dist/antd.css";
import "./style.css";

import { userData } from '../../utils';

class Tweet extends React.Component {

    static defaultProps = {
        image: "https://www.getbadnews.com/wp-content/uploads/2017/08/profile.png",
        name: "Name",
        description: "Profile Description",
        tweet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse accumsan aliquam varius.",
    }

    state = {
        image: this.props.image,
        name: this.props.name,
        description: this.props.description,
        tweet: this.props.tweet,
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let image = nextProps.image;
        if (String(nextProps.image).includes("userData")) {
            const key = nextProps.image.split('.')[nextProps.image.split('.').length-1];
            image = userData[key];
        }
        image = this.replaceUserData(image);

        let name = nextProps.name;
        if (String(nextProps.name).includes("userData")) {
            const key = nextProps.name.split('.')[nextProps.name.split('.').length-1];
            name = userData[key];
        }
        name = this.replaceUserData(name);
        
        let tweet = nextProps.tweet;
        if (String(nextProps.tweet).includes("userData")) {
            const key = nextProps.tweet.split('.')[nextProps.tweet.split('.').length-1];
            tweet = userData[key];
        }
        tweet = this.replaceUserData(tweet);
        

        let description = nextProps.description;
        if (String(nextProps.description).includes("userData")) {
            const key = nextProps.description.split('.')[nextProps.description.split('.').length-1];
            description = userData[key];
        }
        description = this.replaceUserData(description);

        this.setState({
            image: image,
            name: name,
            tweet: tweet,
            description: description
        })
    }

    replaceUserData(text) {
        if (String(text).includes("{{") && String(text).includes("}}")) {
            const keyToReplace = text.substring(text.indexOf("{{"), text.indexOf("}}")+2);
            const key = text.substring(text.indexOf("{{")+2, text.indexOf("}}"));
            text = text.replace( keyToReplace, userData[key] );
        }

        if (String(text).includes("{{") && String(text).includes("}}")) return this.replaceUserData(text)
        else return text;
    }

    render() {
        return (
            <div style={{ width: "95%" }}>
                <Card
                    className="tweetCard"
                    hoverable
                >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "25%" }}>
                            <img className="tweetImg" src={this.state.image} alt="" />
                        </div>
                        <div>
                            <p className="tweetName" >{this.state.name}</p>
                            <p className="tweetDescription" >{this.state.description}</p>

                        </div>
                    </div>
                    <p className="tweetContent" >{this.state.tweet}</p>
                </Card>
            </div>
        );
    }
}


export default Tweet;